import { render } from "./VWater.vue?vue&type=template&id=f3568890"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VWater.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3568890"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3568890', __exports__)) {
    api.reload('f3568890', __exports__)
  }
  
  module.hot.accept("./VWater.vue?vue&type=template&id=f3568890", () => {
    api.rerender('f3568890', render)
  })

}


export default __exports__